export const meta = {
  title: 'Acceptable Use Policy | CADCraft AI',
  description:
    'Rules for using cadcraft.org, its CADCraft guides and the hosted online version of CADCraft.',
  updated_at: '2026-10-20',
};

## Scope

This policy applies to everyone who uses cadcraft.org ("the site"), operated by CADCraft AI. The site provides CADCraft download and installation guides, a comparison of CADCraft with Autodesk AutoCAD, tutorials and a hosted copy of the CADCraft web app. By using the site you agree to follow these rules alongside our [Terms of Service](/terms-of-service).

## What you may do

- Read, share and link to our guides, tutorials and comparisons.
- Use the hosted CADCraft web app to create, open, edit, save and export your own drawings.
- Download CADCraft from the official GitHub releases we link to, and use it under its MIT OR Apache-2.0 license.
- Quote short passages of our content with a link back to the original page.

## What you may not do

- **Attack or overload the site.** No denial-of-service attempts, vulnerability scanning without permission, or automated traffic that degrades the service for others.
- **Scrape at scale.** Do not copy the site wholesale or mirror it in a way that harms its operation or misleads visitors about its source.
- **Misrepresent the site.** Do not present cadcraft.org as an official Autodesk or ArtCraft property, or claim our content as endorsed by either company.
- **Distribute tampered software.** Do not use links, screenshots or instructions from this site to pass off modified or malicious builds as official CADCraft releases.
- **Break the law.** Do not use the site or the hosted app to infringe copyrights or trademarks, or to process drawings you have no right to use.
- **Abuse support channels.** Do not send spam, harassment or phishing to support@cadcraft.org or through any contact form.

## Your drawings

On the free plan, drawings you work on in the hosted CADCraft app stay in your browser and are not uploaded to our servers. With CADCraft Online Pro they are also saved to private cloud storage in your account, as described in our Privacy Policy. You are responsible for the content of your own files and for keeping backups.

## Reporting a problem

If you find a security issue, broken or suspicious download link, inaccurate information or a misuse of the site, email [support@cadcraft.org](mailto:support@cadcraft.org). Please include the page URL and a short description.

## Enforcement

We may block traffic, restrict access or remove content that breaks this policy, without notice where necessary to protect the site and its visitors.

## Changes

We may update this policy. The date at the top shows the latest version.
